import * as EJS from 'ejs';
import * as fs from 'fs';
import * as process from 'process';
import {Log, logErr, LogLn, Util} from './Util';
import * as jsbeautify from 'js-beautify';
import * as fse from 'fs-extra';
import {AppJson, View, AppConfig, AppManifest, ComponentId} from './types/App';
import {CtrlButtonTypeGui, MgControlType, SideType, StorageAttributeType, TableWebStyle, WindowType, WindowPosition} from './types/enums/Enums';
import {Themes} from './types/Themes';

import * as _ from 'lodash';

import {TemplateConfig} from "./types/TemplateConfig";
import {getTemplateConfig, prettierConfig} from './config';

import * as prettier from "prettier";
import {GeneratedFileTypes} from './types/enums/GeneratedFileTypes';
import {processJson} from './ProcessJson';
import {FileAPI} from './FileAPI';
import {exec} from "child_process";

const htmlBeautify = jsbeautify.html;
const cssBeautify  = jsbeautify.css;

// @dynamic
export class SingleControlFactory {
    static view: View;
    static magic_config: AppConfig;

    ////////////////////////////////////////////////
    // input point for the entire generation process
    ////////////////////////////////////////////////
    static init(): void {
        FileAPI.enableLogging = false;

        // get the input directory from the command line argument
        FileAPI.inputRoot = process.argv[2] + '\\';

        // read the config.json file
        this.magic_config = FileAPI.readInputConfig();

        // read the views (= forms) json file
        this.view = FileAPI.readInputJsonAsView();

        // process the views objects, get the classes used for each control
        // LogLn("prepare classes...");
        //this.app = processJson(this.app);

        // build the files for each and every view
        this.buildView(this.magic_config.output_folder + '\\');
    };

    ////////////////////////////////////////////////
    // build the files for all views
    ////////////////////////////////////////////////
    static buildView(outputDir: string): void {
            const
                viewId = this.view.props.id,

                data = {
                    MgControlType: MgControlType,
                    theme: this.magic_config.theme,
                    CtrlButtonTypeGui: CtrlButtonTypeGui,
                    SideType: SideType,
                    StorageAttributeType: StorageAttributeType,
                    TableWebStyle: TableWebStyle,
                    WindowType: WindowType,
                    WindowPosition: WindowPosition,
                    Util: Util,
                    child: this.view,
                    view: this.view,
                    _: _,
                    magicConfig: this.magic_config,
                },

                // templates for creating different output files
                componentFile: TemplateConfig =
                    {
                        type: GeneratedFileTypes.HTML,
                        template: './src/templates/themes/control.ejs',
                        destination: null,
                        name: `${viewId}.component.html`,
                        data: data
                    };


            this.generate(componentFile);
    };

    ////////////////////////////////////////////////
    // generate file using the specified template
    ////////////////////////////////////////////////
    static generate(file: TemplateConfig) {
        EJS.renderFile(file.template, file.data, {}, (err, output) => {
            if (err) {
                logErr(err);
            }

            try {
                output = htmlBeautify.bind(this, output, {
                    "max_preserve_newlines": 0,
                    "wrap_line_length": 0,
                    "wrap_attributes": "force-expand-multiline"
                })();

            }
            catch (err) {

                logErr(output);
                logErr(err);

            }

            Log(output);

        });

    }

}

//SingleControlFactory.init();











